import { render, staticRenderFns } from "./exportCandidateAllInfo.vue?vue&type=template&id=1388bb32&scoped=true"
import script from "./exportCandidateAllInfo.vue?vue&type=script&lang=js"
export * from "./exportCandidateAllInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1388bb32",
  null
  
)

export default component.exports